import React from 'react';
import PropTypes from 'prop-types';
import { cx } from './classNames';

/**
 * A determinate progress bar (MUI's LinearProgress in the primary colour, as
 * the optimizer sizes it): a 5px rounded track in a light tint of the accent
 * with an accent bar `value`% long (clamped to 0-100). It is a
 * role="progressbar" with its value; name it with `aria-label`. Other props
 * go to the track.
 */
export default function Progress({ value, className, ...trackProps }) {
    const percent = Math.min(100, Math.max(0, Number(value) || 0));
    return (
        <span
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={Math.round(percent)}
            className={cx('relative block h-[5px] overflow-hidden rounded-full bg-accent/[0.38] dark:bg-accent/50', className)}
            {...trackProps}
        >
            <span
                aria-hidden="true"
                className="absolute inset-y-0 left-0 block bg-accent transition-[width] duration-300"
                style={{ width: `${percent}%` }}
            />
        </span>
    );
}

Progress.propTypes = {
    value: PropTypes.number.isRequired,
    className: PropTypes.string,
};
